export default __webpack_public_path__ + "static/media/gq.777b51e5.svg";